<div class="fancy-viewer-container">

	<!-- Sidebar Table of Contents -->
	<aside *ngIf="tableOfContents.length" class="toc-sidebar" [class.toc-collapsed]="tocCollapsed">

		<div class="toc-card">
			<div class="toc-header">
				<h4 class="toc-title">Contents</h4>

				<button type="button" class="toc-collapse-btn" (click)="toggleToc()" [attr.aria-expanded]="!tocCollapsed">
					Hide <span class="toc-collapse-arrow">‹</span>
				</button>
			</div>


			<ul class="toc-list" *ngIf="!tocCollapsed">
				<li *ngFor="let item of tableOfContents" [class.active]="isActive(item)" [ngStyle]="{ 'margin-left.px': (item.level - 1) * 18 }">
					<a href="javascript:void(0)" (click)="scrollTo(item.id)" class="toc-link">
						<span class="toc-bullet"></span> {{ item.title }}
					</a>
				</li>
			</ul>

			<!-- Collapsed tab (only visible when collapsed) -->
			<button *ngIf="tocCollapsed" type="button" class="toc-collapsed-tab" (click)="toggleToc()" aria-label="Show contents">
				<span class="toc-tab-icon">›</span>
				<span class="toc-tab-label">Contents</span>
			</button>
		</div>
	</aside>




	<!-- Main Content -->
	<main class="article-container" #contentContainer>
		<div class="stepper-card">

			<div class="step-header">
				<h2>{{ title }}</h2>

				<!-- Page Badge -->
				<div class="step-number-badge">
					Page {{ currentStepIndex + 1 }} / {{ steps.length }}
				</div>

				<!-- Segmented Stepper -->
				<div class="step-progress">
					<ng-container *ngFor="let step of steps; let i = index">
						<div class="step-segment" [class.fill]="i <= currentStepIndex"></div>
					</ng-container>
				</div>

			</div>

			<div class="step-content" [innerHTML]="currentStepContent" appHtmlImageSkeleton></div>

			<div class="step-controls">
				<button class="btn-nav" (click)="previousStep()" [disabled]="currentStepIndex === 0">
					<span class="arrow">←</span>
					Previous
				</button>

				<button class="btn-nav" (click)="nextStep()" [disabled]="currentStepIndex === steps.length - 1">
					Next
					<span class="arrow">→</span>
				</button>
			</div>

		</div>

		<p *ngIf="steps.length === 0" class="empty-message">
			No content available.
		</p>
	</main>
</div>

<!-- Image Lightbox Modal -->
<div class="image-overlay" *ngIf="lightboxImage" (click)="closeLightbox()">
	<img [src]="lightboxImage" alt="Preview" class="image-popup" (click)="$event.stopPropagation()" />
</div>
